import React from "react";

const STYLES = {
  green: "text-emerald-400 bg-emerald-500/10 border-emerald-500/25",
  yellow: "text-amber-400 bg-amber-500/10 border-amber-500/25",
  red: "text-rose-400 bg-rose-500/10 border-rose-500/25",
  gray: "text-slate-400 bg-slate-500/10 border-slate-500/25",
};

const LABELS = {
  current: "Current",
  expiring_soon: "Expiring Soon",
  expiring_90: "≤ 90 Days",
  expiring_60: "≤ 60 Days",
  expiring_30: "≤ 30 Days",
  expired: "Expired",
  none: "No Credentials",
};

export default function StatusBadge({ status, color, className = "", testId }) {
  const s = color || (
    status === "expired" ? "red" :
    status?.startsWith("expiring") ? "yellow" :
    status === "none" ? "gray" : "green"
  );
  const label = LABELS[status] || status;
  return (
    <span
      data-testid={testId}
      className={`inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-xs font-semibold border ${STYLES[s]} ${className}`}
    >
      <span className={`w-1.5 h-1.5 rounded-full ${
        s === "green" ? "bg-emerald-400" :
        s === "yellow" ? "bg-amber-400" :
        s === "red" ? "bg-rose-400" : "bg-slate-400"
      }`} />
      {label}
    </span>
  );
}
